'use client'

import React from 'react'

type Props = {
    speedMs: number
    angleDeg: number
    initialHeightM: number
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 40
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM
const G = 9.81

export default function ProjectileTrajectoryChart({ speedMs, angleDeg, initialHeightM }: Props) {
    const rad = (angleDeg * Math.PI) / 180
    const vx = Math.max(speedMs, 0) * Math.cos(rad)
    const vy = Math.max(speedMs, 0) * Math.sin(rad)
    const h0 = Math.max(initialHeightM, 0)

    const disc = vy * vy + 2 * G * h0
    const totalTime = (vy + Math.sqrt(Math.max(disc, 0))) / G || 0.0001
    const maxX = vx * totalTime || 1
    const maxY = Math.max(h0 + (vy * vy) / (2 * G), h0, 1)

    const xToSvg = (x: number) => PAD_LEFT + (x / maxX) * PLOT_W
    const yToSvg = (y: number) => PAD_TOP + PLOT_H - (y / maxY) * PLOT_H

    const points: string[] = []
    const steps = 60
    for (let i = 0; i <= steps; i++) {
        const time = (totalTime * i) / steps
        const x = vx * time
        const y = h0 + vy * time - 0.5 * G * time * time
        points.push(`${xToSvg(x).toFixed(1)},${yToSvg(Math.max(y, 0)).toFixed(1)}`)
    }

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={HEIGHT - PAD_BOTTOM} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">Range (m)</text>
            <text x={4} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">Height (m)</text>
            <polyline points={points.join(' ')} fill="none" stroke="#2563eb" strokeWidth={2} />
            <circle cx={xToSvg(0)} cy={yToSvg(h0)} r={4} fill="#16a34a" stroke="#fff" strokeWidth={1.5} />
            <circle cx={xToSvg(maxX)} cy={yToSvg(0)} r={4} fill="#dc2626" stroke="#fff" strokeWidth={1.5} />
        </svg>
    )
}
